import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=b060c944"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports